export default [{
    path: '/sms-templates',
    name: 'sms-templates',
    component: () => import('@/views/modules/Sms/templates.vue'),
    meta: {
      breadcrumb: [{
          text: 'navbars.sms_sending',
          active: true,
        },
        {
          text: 'navbars.sms_templates',
          active: true,
        },
      ],
      unique_name: "sms-templates"
    },
  },
  {
    path: '/sms-sending',
    name: 'sms-sending',
    component: () => import('@/views/modules/Sms/clients.vue'),
    meta: {
      breadcrumb: [{
          text: 'navbars.sms_sending',
          active: true,
        },
        {
          text: 'navbars.sms_sending_to_clients',
          active: true,
        },
      ],
      unique_name: "sms-sending"
    },
  },
  {
    path: '/auto-sms',
    name: 'auto-sms',
    component: () => import('@/views/modules/Sms/autoSms.vue'),
    meta: {
      breadcrumb: [{
          text: 'navbars.sms_sending',
          active: true,
        },
        {
          text: 'navbars.sms_auto_sending_clients',
          active: true,
        },
      ],
      unique_name: "auto-sms"
    },
  },
]